import { defineStyles } from "@pandacss/dev";

export const baseInputTrigger = defineStyles({
  _aromaticonChildren: {
    fontSize: "{sizes.xs}",
  },
  display: "flex",
  placeContent: "center",
  placeItems: "center",
  border: "{borderWidths.m} solid",
  borderColor: "transparent",
  bgColor: {
    base: "background.neutral.base.subtlest",
    _hover: "background.neutral.base.subtlest-hover",
    _disabled: "background.neutral.disable.subtle",
  },
  _active: {
    borderColor: "border.brand-bold",
  },
  position: "absolute",
  right: "calc({spacing.padding.1} - {borderWidths.m})",
  color: {
    base: "content.neutral.base.subtle",
    _disabled: "content.neutral.base.disable",
  },
  cursor: {
    base: "unset",
    _disabled: "not-allowed",
  },
});

export const smallInputTigger = defineStyles({
  height: "s",
  width: "s",
  padding: "padding.0,5",
  borderRadius: "xs",
});

export const mediumInputTigger = defineStyles({
  height: "m",
  width: "m",
  padding: "padding.1,5",
  borderRadius: "s",
});
